import { render, staticRenderFns } from "./RomaActivityModalForm.vue?vue&type=template&id=40093876"
import script from "./RomaActivityModalForm.vue?vue&type=script&lang=ts"
export * from "./RomaActivityModalForm.vue?vue&type=script&lang=ts"
import style0 from "./RomaActivityModalForm.vue?vue&type=style&index=0&id=40093876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports